import StringUtils from "util/StringUtils";
const ViewTypeLabel = ({ type, capitalize = false }) => {
  if (!type) {
    return "";
  }
  const typeLabel = type.toLowerCase();
  return capitalize ? StringUtils.capitalizeFirstLetter(typeLabel) : typeLabel;
};
export default ViewTypeLabel;
